import React, { useState } from 'react';
import MediaQuery from 'react-responsive';
import { t } from 'i18next';
import clsx from 'clsx';
import Step from '../../components/step';
import Input from '../../components/input';
import ActionFooter from '../../components/action-footer';
import styles from './index.module.scss';

export default function LoginOtp(props) {
  const [initialFocus, setInitialFocus] = useState(false);
  const [otpRef, setOtpRef] = useState(undefined);
  const [otp, setOtp] = useState('');
  const {
    step,
    currentStep,
    token,
    onBackClick,
    onLoginClick,
    onResendOtpClick,
    onInputChange,
    error,
  } = props;

  if (step !== currentStep && initialFocus) {
    setInitialFocus(false);
  } else if (step == currentStep && !initialFocus && otpRef) {
    setInitialFocus(true);
    setOtp('');
    onInputChange && onInputChange('');
    setTimeout(() => {
      if (step == currentStep) {
        otpRef && otpRef.focus();
      }
    }, 300);
  }

  return (
    <Step className="stepstyles" number={step} current={currentStep}>
      <MediaQuery minHeight={410}>
        <div className={clsx(styles.logo, 'logo', 'otp-logo')} />
      </MediaQuery>

      <div className="otp-container">
        {/* Text */}
        <MediaQuery minHeight={400}>
          <div className={clsx(styles.header1, 'header1', 'otp-header1')}>
            {t('login-otp.text')}
          </div>
          <div className={clsx(styles.header2, 'header2', 'otp-header2')}>
            {t('login-otp.subtext')} <b>{token}</b>. {t('login-otp.subtext_continue')}
          </div>
        </MediaQuery>

        {/* Login field */}
        <div className={clsx(styles.input, 'input', 'otp-input')}>
          <Input
            ref={(element) => setOtpRef(element)}
            placeholder={t('login-otp.otp')}
            style={{ width: '80%' }}
            type="password"
            value={otp}
            onChange={(e) => {
              setOtp(e.target.value);
              onInputChange && onInputChange(e.target.value);
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                if (!otp || otp.length == 0) {
                  otpRef && otpRef.focus();
                }
                onLoginClick(otp);
              }
            }}
            helperText={error}
          />
        </div>

        <div className={clsx(styles.resend, 'otp-resend')}>
          {t('login-otp.helper_text')}{' '}
          <font onClick={(e) => onResendOtpClick()}>{t('login-otp.resend_code')}</font>
        </div>
      </div>

      {/* Buttons */}
      <ActionFooter
        backText={t('login-otp.back_button')}
        nextText={t('login-otp.next_button')}
        onNextClick={() => {
          if (!otp || otp.length == 0) {
            otpRef && otpRef.focus();
          }
          onLoginClick(otp);
        }}
        onBackClick={() => onBackClick()}
      />
    </Step>
  );
}
